var render = function render(){var _vm=this,_c=_vm._self._c;return _c('treeselect',{attrs:{"name":_vm.name,"options":_vm.options,"multiple":false,"clearable":true,"searchable":true,"noResultsText":"Nichts gefunden","placeholder":"Vertretung suchen…"},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})
}
var staticRenderFns = []

export { render, staticRenderFns }